/**
 * White belt on a white surface (#765 bug 2, 2026-09-23).
 *
 * The white belt's colour is #ffffff, and Mist's surfaces are white, so any
 * text or dot painted in the belt colour vanished: "White Belt" in the belt
 * sheet, the dot in the resting pill, the Library belt card. Text in a near-white
 * belt colour is set in ink instead, and a near-white dot gets a hairline ring.
 * The belt colours and thresholds themselves are unchanged.
 */
const INK = 'var(--text-primary, #2C2622)'

export function isNearWhiteBelt(color: string | null | undefined): boolean {
  if (!color) return false
  const m = color.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if (!m) return false
  const hex = m[1].length === 3 ? m[1].split('').map((c) => c + c).join('') : m[1]
  // Parse once per contrast check; each byte is one RGB channel.
  const rgb = parseInt(hex, 16)
  const r = (rgb >> 16) / 255
  const g = ((rgb >> 8) & 255) / 255
  const b = (rgb & 255) / 255
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.9
}

/** The colour to set belt-coloured TEXT in: the belt's own, or ink for a white belt. */
export function beltTextColor(color: string | null | undefined): string {
  return isNearWhiteBelt(color) ? INK : (color || INK)
}

/** A hairline ring for a belt-coloured DOT that would otherwise vanish on white. */
export function beltDotRing(color: string | null | undefined): string | undefined {
  return isNearWhiteBelt(color) ? 'inset 0 0 0 1px rgba(44, 38, 34, 0.45)' : undefined
}
